import {
  UPDATE_OVERTIME_REQUEST_PENDING,
  UPDATE_OVERTIME_REQUEST_ERROR,
  UPDATE_OVERTIME_REQUEST_SUCCESS,
  SET_UPDATE_OVERTIME_REQUEST_FORM_INITIAL_STATE,
  UPDATE_TIME_ADJUSTMENT_REQUEST_PENDING,
  UPDATE_TIME_ADJUSTMENT_REQUEST_ERROR,
  UPDATE_TIME_ADJUSTMENT_REQUEST_SUCCESS,
  SET_UPDATE_TIME_ADJUSTMENT_REQUEST_FORM_INITIAL_STATE,
  OPEN_OVERTIME_REQUEST_MODAL,
  CLOSE_OVERTIME_REQUEST_MODAL,
  OPEN_TIME_ADJUSTMENT_REQUEST_MODAL,
  CLOSE_TIME_ADJUSTMENT_REQUEST_MODAL,
} from './constants';

const INIT_STATE = {
  updateOverTimeErrorMessage: null,
  updateTimeAdjustmentErrorMessage: null,
  isUpdateOverTimeRequestsPending: false,
  isUpdateTimeAdjustmentRequestsPending: false,
  isOpenOverTimeRequestModal: false,
  isOpenTimeAdjustmentRequestModal: false,
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_OVERTIME_REQUEST_PENDING: {
      return {
        ...localState,
        isUpdateOverTimeRequestsPending: true,
      };
    }
    case UPDATE_OVERTIME_REQUEST_SUCCESS: {
      return {
        ...localState,
        isUpdateOverTimeRequestsPending: false,
      };
    }
    case UPDATE_OVERTIME_REQUEST_ERROR: {
      return {
        ...localState,
        isUpdateOverTimeRequestsPending: false,
        updateOverTimeErrorMessage: action.payload,
      };
    }
    case SET_UPDATE_OVERTIME_REQUEST_FORM_INITIAL_STATE: {
      return {
        ...localState,
        isUpdateOverTimeRequestsPending: false,
        updateOverTimeErrorMessage: null,
      };
    }
    case UPDATE_TIME_ADJUSTMENT_REQUEST_PENDING: {
      return {
        ...localState,
        isUpdateTimeAdjustmentRequestsPending: true,
      };
    }
    case UPDATE_TIME_ADJUSTMENT_REQUEST_ERROR: {
      return {
        ...localState,
        isUpdateTimeAdjustmentRequestsPending: false,
        updateTimeAdjustmentErrorMessage: action.payload,
      };
    }
    case UPDATE_TIME_ADJUSTMENT_REQUEST_SUCCESS: {
      return {
        ...localState,
        isUpdateTimeAdjustmentRequestsPending: false,
      };
    }
    case SET_UPDATE_TIME_ADJUSTMENT_REQUEST_FORM_INITIAL_STATE: {
      return {
        ...localState,
        isUpdateTimeAdjustmentRequestsPending: false,
        updateTimeAdjustmentErrorMessage: null,
      };
    }
    case OPEN_OVERTIME_REQUEST_MODAL: {
      return {
        ...localState,
        isOpenOverTimeRequestModal: true,
      };
    }
    case CLOSE_OVERTIME_REQUEST_MODAL: {
      return {
        ...localState,
        isOpenOverTimeRequestModal: false,
      };
    }
    case OPEN_TIME_ADJUSTMENT_REQUEST_MODAL: {
      return {
        ...localState,
        isOpenTimeAdjustmentRequestModal: true,
      };
    }
    case CLOSE_TIME_ADJUSTMENT_REQUEST_MODAL: {
      return {
        ...localState,
        isOpenTimeAdjustmentRequestModal: false,
      };
    }
    default:
      return { ...localState };
  }
};
